"use client";

import {
  APP_STORE_URLS,
  trackAppStoreClick,
  type AppDownloadPlatform,
} from "@/lib/app-download";
import type { AnchorHTMLAttributes, ReactNode } from "react";

type Props = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  platform: AppDownloadPlatform;
  children: ReactNode;
};

/** Store link with fire-and-forget click tracking (client island). */
export function StoreDownloadLink({
  platform,
  children,
  onClick,
  ...rest
}: Props) {
  return (
    <a
      href={APP_STORE_URLS[platform]}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => {
        trackAppStoreClick(platform);
        onClick?.(e);
      }}
      {...rest}
    >
      {children}
    </a>
  );
}
